import { createContext, useContext, type ReactNode } from 'react';
import useAllConversations, { type UseAllConversationsResult } from '@/hooks/useAllConversations';

/**
 * Single app-wide instance of the conversation listeners — powers the chat
 * sidebar, the title/favicon unread badge, and browser notifications without
 * duplicating Firestore listener sets across consumers.
 */
const ConversationsContext = createContext<UseAllConversationsResult | undefined>(undefined);

export function ConversationsProvider({ children }: { children: ReactNode }) {
  const value = useAllConversations();
  return <ConversationsContext.Provider value={value}>{children}</ConversationsContext.Provider>;
}

export function useConversations(): UseAllConversationsResult {
  const context = useContext(ConversationsContext);
  if (context === undefined) {
    throw new Error('useConversations must be used within ConversationsProvider');
  }
  return context;
}
